var React = require('react');

function Document (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.85 18h22.3c.744 0 1.487-.4 1.487-1.4 0-1-.743-1.6-1.486-1.6H12.85c-.93 0-1.487.8-1.487 1.6s.743 1.4 1.487 1.4zm22.3 9h-22.3c-.744 0-1.487-.6-1.487-1.6s.743-1.4 1.487-1.4h22.3c.744 0 1.487.6 1.487 1.6s-.743 1.4-1.486 1.4zm-22.3 9H24c.743 0 1.487-.6 1.487-1.6s-.744-1.6-1.487-1.6H12.85c-.93 0-1.487.6-1.487 1.6s.743 1.6 1.487 1.6z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.274 48h33.452c2.23 0 4.088-2 4.274-4.6V10.2c0-1.2-.557-2.4-1.3-3.2l-5.576-5.8C37.194.4 36.266 0 35.15 0H7.274C4.858 0 3 2 3 4.6v39C3 46 4.858 48 7.274 48zM5.788 4.6c0-1 .743-1.6 1.486-1.6h28.062c.372 0 .744.2.93.4l5.575 5.8c.185.2.371.6.371 1v33.4c0 1-.743 1.6-1.486 1.6H7.274c-.929 0-1.486-.8-1.486-1.6v-39z","key":1})]);
}

Document.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Document;

Document.default = Document;
